import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "toggleLink"]
  static values = {
    visibleCount: { type: Number, default: 2 },
    expanded: { type: Boolean, default: false },
    showMoreText: { type: String, default: "Show more" },
    showLessText: { type: String, default: "Show less" }
  }

  connect() {
    this.updateVisibility()
  }

  toggle(event) {
    event.preventDefault()
    this.expandedValue = !this.expandedValue
    this.updateVisibility()
  }

  updateVisibility() {
    const items = this.itemTargets

    items.forEach((item, index) => {
      if (index < this.visibleCountValue || this.expandedValue) {
        item.classList.remove("hidden")
      } else {
        item.classList.add("hidden")
      }
    })

    if (this.hasToggleLinkTarget) {
      this.toggleLinkTarget.textContent = this.expandedValue
        ? this.showLessTextValue
        : this.showMoreTextValue
    }
  }
}
